export default __webpack_public_path__ + "static/media/lg-hausys.9275b9de.png";